export default {"src":"/_next/static/media/close.402fa47f.svg","height":50,"width":50,"blurWidth":0,"blurHeight":0};